import type { ApolloError } from 'apollo-client';
import type { GraphQLError } from 'graphql';

import {
	isFeedConfigDeletedSpaceError,
	isFeedConfigSpacePermissionError,
	isFeedConfigUserPermissionError,
} from '@confluence/activity-filter';

export const isExpectedApolloError = (error: ApolloError): boolean => {
	return error.graphQLErrors.every(isExpectedGraphqlError);
};

const isExpectedGraphqlError = (error: GraphQLError) => {
	return (
		isFeedConfigDeletedSpaceError(error) ||
		isFeedConfigSpacePermissionError(error) ||
		isFeedConfigUserPermissionError(error) ||
		isFeedDeletedCommentError(error) ||
		isFeedRecDeletedSpaceError(error) ||
		isSummaryLineUpdateUserPermissionError(error)
	);
};

const commentErrorPath = ['summaryLineUpdate', 'comment'];
// Deleted comment error for when the feed attempts to hydrate a deleted comment
const isFeedDeletedCommentError = (error: GraphQLError) => {
	return (
		commentErrorPath.every((path) => error.path?.includes(path)) &&
		error.message?.includes('No comment found for the given id')
	);
};

const feedRecDeletedSpacePath = ['getRecommendedFeedUserConfig', 'recommendedSpaces', 'space'];
export const isFeedRecDeletedSpaceError = (error: GraphQLError) => {
	return (
		feedRecDeletedSpacePath.every((path) => error.path?.includes(path)) &&
		error.message.includes('Cannot find space with id')
	);
};

const summaryLineUpdateUserPath = ['feed', 'nodes', 'summaryLineUpdate', 'user'];
export const isSummaryLineUpdateUserPermissionError = (error: GraphQLError) => {
	return (
		summaryLineUpdateUserPath.every((path) => error.path?.includes(path)) &&
		error.message?.includes('User not permitted to access Confluence')
	);
};
